/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Menu } from '@neo4j-ndl/react';
import { MoreFiles } from '@neo4j-ndl/react/ai';
import {
  DocumentIconOutline,
  PhotoIconOutline,
  TableCellsIconOutline,
} from '@neo4j-ndl/react/icons';
import { useRef, useState } from 'react';

const Component = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <MoreFiles
        count={3}
        isActive={isMenuOpen}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        ref={anchorRef}
      />
      <Menu
        isOpen={isMenuOpen}
        anchorRef={anchorRef}
        onClose={() => setIsMenuOpen(false)}
      >
        <Menu.Item
          leadingVisual={<DocumentIconOutline />}
          title="Science fiction bestseller"
          description="PDF"
          onClick={() => alert('Science fiction bestseller')}
        />
        <Menu.Item
          leadingVisual={<TableCellsIconOutline />}
          title="MoviesDecade"
          description="CSV"
          onClick={() => alert('MoviesDecade')}
        />
        <Menu.Item
          leadingVisual={<PhotoIconOutline />}
          title="Family photo"
          description="JPG"
          onClick={() => alert('Family photos')}
        />
      </Menu>
    </>
  );
};

export default Component;
